const SOURCE_LABEL = String.raw`source(?:[\s_]*(?:id|ids))?`;
const SOURCE_REF_VALUE = String.raw`(?:\[\s*(?:\d+(?:\s*,\s*\d+)*)?\s*\]|\d+(?:\s*,\s*\d+)*)`;

const PARENTHESIZED_SOURCE_REF_RE = new RegExp(
  String.raw`\s*\(\s*${SOURCE_LABEL}\b\s*:?\s*${SOURCE_REF_VALUE}\s*\)`,
  "gi",
);
const BARE_SOURCE_REF_RE = new RegExp(
  String.raw`\b${SOURCE_LABEL}\b\s*:?\s*${SOURCE_REF_VALUE}`,
  "gi",
);
const BRACKETED_REF_RE = /\s*\[\s*\d+(?:\s*,\s*\d+)*\s*\]/g;
const EMPTY_BRACKETS_RE = /(^|[\s(])\[\s*\](?=$|[\s).,;:!?])/g;
const PLACEHOLDER_SOURCE_ID_RE = new RegExp(
  String.raw`^(?:${SOURCE_LABEL}\b\s*:?\s*)?${SOURCE_REF_VALUE}$`,
  "i",
);
const NUMERIC_SOURCE_ID_RE = /^\d+(?:\s*,\s*\d+)*$/;

/**
 * Strip LLM-generated source references from display text.
 */
export const stripSourceRefs = (s: string): string =>
  s
    .replace(PARENTHESIZED_SOURCE_REF_RE, "")
    .replace(BARE_SOURCE_REF_RE, "")
    .replace(BRACKETED_REF_RE, "")
    .replace(EMPTY_BRACKETS_RE, "$1")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/ *([),.;:!?])/g, "$1")
    .replace(/\(\s*\)/g, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

/**
 * Hide placeholder source-id payloads like "0", "[0]", or "source id 0"
 * while preserving real source labels and URLs.
 */
export const sanitizeSourceId = (value?: string | null): string | null => {
  if (!value) {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  if (
    PLACEHOLDER_SOURCE_ID_RE.test(trimmed) ||
    NUMERIC_SOURCE_ID_RE.test(trimmed)
  ) {
    return null;
  }

  const cleaned = stripSourceRefs(trimmed);
  return cleaned || null;
};
